import { Injectable } from "@angular/core";
import { NzModalService, UploadFile } from "ng-zorro-antd";

type ModalSizeType = "small" | "medium" | "large";
export interface ModalOptions {
  nzContent: any; //组件
  size: ModalSizeType; //小/中/大
  nzTitle?: string; //标题
  primaryLabel?: string; //按钮‘label’,不传默认为‘确定’
  vertical?: boolean; //弹框是否为垂直居中，默认不垂直居中
  hideBtn?: boolean; //是否隐藏footer按钮
  showResetBtn?: boolean; //是否显示重置按钮
}
@Injectable({
  providedIn: "root",
})
export class KreDialogService {
  constructor(public modalService: NzModalService) {}
  switchSize(size: any) {
    const obj = {
      width: 700,
      height: 500,
    };
    switch (size) {
      case "small":
        obj.width = 530;
        obj.height = 400;
        break;
      case "medium":
        obj.width = 700;
        obj.height = 500;
        break;
      case "large":
        obj.width = 950;
        obj.height = 600;
        break;
      default:
        obj.width = 700;
        obj.height = 500;
        break;
    }
    return obj;
  }
  public CreateModelDialog(
    modalOptions: ModalOptions,
    params: any,
    callback: any
  ) {
    const width = this.switchSize(modalOptions.size).width;
    const height = this.switchSize(modalOptions.size).height;
    const modal: any = this.modalService.create({
      nzTitle: modalOptions.nzTitle ? modalOptions.nzTitle : "提示",
      nzWidth: width + "px",
      nzClosable: true,
      nzMaskClosable: false,
      nzWrapClassName: modalOptions["vertical"] ? "vertical-center-modal" : "",
      nzBodyStyle: {
        padding: "0",
        height: !modalOptions["hideBtn"]
          ? height - 107 + "px"
          : height - 54 + "px",
      },
      nzContent: modalOptions.nzContent,
      nzFooter: !modalOptions["hideBtn"]
        ? [
            {
              show: true,
              label: "取消",
              type: "default",
              onClick: (componentInstance) => {
                modal.destroy();
              },
            },
            {
              show: modalOptions["showResetBtn"],
              label: "重置",
              type: "default",
              onClick: (componentInstance) =>
                callback(componentInstance, modal),
            },
            {
              show: true,
              label: modalOptions["primaryLabel"]
                ? modalOptions["primaryLabel"]
                : "确定",
              type: "primary",
              onClick: (componentInstance) =>
                callback(componentInstance, modal),
            },
          ]
        : null,
      nzOnOk: (data) => {},
      nzOnCancel: (data) => {},
      nzComponentParams: params,
    });

    modal.afterClose.subscribe((result: any) => {
      if (result) {
        callback(result);
      }
    });
  }

  public CreateModelDialogField(
    modalOptions: ModalOptions,
    params: any,
    callback: any
  ) {
    const width = this.switchSize(modalOptions.size).width;
    const height = this.switchSize(modalOptions.size).height;
    const modal: any = this.modalService.create({
      nzTitle: modalOptions.nzTitle ? modalOptions.nzTitle : "提示",
      nzWidth: width + "px",
      nzClosable: true,
      nzMaskClosable: false,
      nzWrapClassName: modalOptions["vertical"] ? "vertical-center-modal" : "",
      nzBodyStyle: {
        padding: "0",
        height: !modalOptions["hideBtn"]
          ? height - 107 + "px"
          : height - 54 + "px",
      },
      nzContent: modalOptions.nzContent,
      nzFooter: !modalOptions["hideBtn"]
        ? [
            {
              show: true,
              label: "取消",
              type: "default",
              onClick: (componentInstance) => {
                modal.destroy();
              },
            },
            {
              show: true,
              label: modalOptions["primaryLabel"]
                ? modalOptions["primaryLabel"]
                : "确定",
              type: "primary",
              onClick: (componentInstance) =>
                callback("save", componentInstance, modal),
            },
          ]
        : null,
      nzOnOk: (data) => {},
      nzOnCancel: (data) => {},
      nzComponentParams: params,
    });

    modal.afterClose.subscribe((result: any) => {
      if (result) {
        callback(result);
      }
    });
  }
}
